import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {VehicleTransaction} from '../../models/vte';
import {OperationsMetrics, OperationsMetricsService} from '../../services/vte/operations-metrics.service';
import {resolveTransactionStatusBadge} from '../../services/vte/vte.constants';
import {VisionConfigService} from '../../services/vte/vision-config.service';

@Component({
    selector: 'app-operations-home',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './operations-home.component.html',
    styleUrl: './operations-home.component.css',
})
export class OperationsHomeComponent implements OnInit {
    metricsLoading = true;
    metrics: OperationsMetrics = {
        completed: 0,
        waiting: 0,
        needsAttention: 0,
        failed: 0,
        latestTransaction: null,
    };

    constructor(
        public visionConfig: VisionConfigService,
        private metricsService: OperationsMetricsService,
        private router: Router,
    ) {
    }

    ngOnInit(): void {
        this.loadMetrics();
    }

    get visionModeLabel(): string {
        const mode = this.visionConfig.visionPolicy.vision_mode || 'disabled';
        return mode.replace(/_/g, ' ');
    }

    loadMetrics(): void {
        this.metricsLoading = true;
        this.metricsService.loadMetrics().subscribe({
            next: (metrics) => {
                this.metrics = metrics;
                this.metricsLoading = false;
            },
            error: () => {
                this.metricsLoading = false;
            },
        });
    }

    navigateToTransactions(statusGroup: string): void {
        this.router.navigate(['/operations/transactions'], {
            queryParams: statusGroup ? {status_group: statusGroup} : {},
        });
    }

    latestTransactionActivityLabel(transaction: VehicleTransaction | null): string {
        if (!transaction) {
            return 'No recent transaction activity';
        }
        const status = resolveTransactionStatusBadge(transaction.status)?.label || transaction.status;
        const plate = transaction.correlated_plate || 'No plate';
        const anchor = transaction.anchor_timestamp
            ? new Date(transaction.anchor_timestamp).toLocaleString()
            : '—';
        return `${plate} · ${status} · ${anchor}`;
    }
}
